var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRearParkingCamera32 = function SvgRearParkingCamera32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17V8.193a6.22 6.22 0 0 1 1.8-4.38A6.12 6.12 0 0 1 10.145 2h11.71A6.12 6.12 0 0 1 26.2 3.814a6.218 6.218 0 0 1 1.8 4.38v13.613a6.218 6.218 0 0 1-1.8 4.38A6.12 6.12 0 0 1 21.855 28H16m-6 2H8.175a6.084 6.084 0 0 1-4.366-1.863A6.46 6.46 0 0 1 2 23.639V22m8 4h-.912a3.03 3.03 0 0 1-2.177-.927A3.252 3.252 0 0 1 6 22.825V22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.624 11h-4.248C10.064 11 9 12.034 9 13.31v2.38C9 16.966 10.064 18 11.376 18h4.248C16.936 18 18 16.966 18 15.69v-2.38c0-1.276-1.064-2.31-2.376-2.31ZM18 12.833l3.189-1.687a1.242 1.242 0 0 1 1.651.466c.105.182.16.388.16.597v4.582a1.2 1.2 0 0 1-.15.579 1.244 1.244 0 0 1-1.588.522L18 16.428",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgRearParkingCamera32;